// Make the Blogs Clickable 
var blogs = document.querySelectorAll(".main-blog .blog-articles > *");
for (var blog of blogs) {
    var cardInner = blog.querySelector(".card-wrapper.underline-links-hover");
    var blogLink = blog.querySelector(".card__heading.h2 > a").href;
    let newCardInner = `<a href="${blogLink}" style="z-index: 2">${cardInner.innerHTML}</a>`;
    cardInner.innerHTML = newCardInner;
}



// Dynamically Update the First Image Banner to the First Blog
var blogMain = document.querySelector("main:has(.main-blog)");

var blogShowcase = blogMain.querySelector("div.shopify-section.section");
var blogShowcaseImg = blogShowcase.querySelector("img");

var firstBlog = blogMain.querySelector(".main-blog .blog-articles .blog-articles__article:first-of-type");
var firstBlogCaption = blogMain.querySelector(".main-blog > h1");
var firstImg = firstBlog.querySelector(".card__inner .article-card__image img");
var firstBlogHeader = firstBlog.querySelector(".card__heading.h2 .full-unstyled-link").textContent;
var firstBlogText = firstBlog.querySelector(".card__information > p");
var firstBlogLink = firstBlog.querySelector(".card__heading.h2 > a").href;

// Change the Image
// blogShowcase.querySelector("img").outerHTML = firstImg.outerHTML;

blogShowcase.querySelector(".image-with-text__text-item.grid__item > .image-with-text__content.content-container > p").textContent = firstBlogCaption.textContent;
blogShowcase.querySelector(".image-with-text__text-item.grid__item > .image-with-text__content.content-container > h2").textContent = firstBlogHeader;
blogShowcase.querySelector(".image-with-text__text-item.grid__item > .image-with-text__content.content-container > div p").textContent = firstBlogText.textContent;
blogShowcase.querySelector(".image-with-text__content > div + a").href = firstBlogLink;